<template>
  <div class="min-h-screen bg-gray-50">
    <div class="max-w-7xl mx-auto px-4 py-8">
      <!-- 头部区域 -->
      <div class="flex justify-between items-center mb-8">
        <h1 class="text-2xl font-bold">业务员会员消费</h1>
        <div class="flex items-center space-x-4">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="large"
            class="!rounded-button"
            @change="loadData"
          />

          <el-button type="primary" class="!rounded-button whitespace-nowrap" @click="querys">
            查询
          </el-button>
          <el-button type="success" class="!rounded-button whitespace-nowrap" @click="exportData">
            <i class="el-icon-download mr-1"></i>导出数据
          </el-button>
        </div>
      </div>

      <!-- 业务员列表 -->
      <div class="bg-white rounded-lg shadow-sm">
        <el-table :data="tableData" stripe v-loading="loading" @selection-change="handleSelectionChange">
          <!-- <el-table-column type="selection" width="45" :selectable="selectable"></el-table-column> -->
          <el-table-column label="业务员" width="200">
            <template slot-scope="{ row }">
              <div class="flex items-center">
                <el-avatar :size="32" :src="row.avatar" />
                <span class="ml-2">{{ row.name }}</span>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column prop="memberCount" label="负责会员数" sortable />

          <el-table-column prop="totalConsumption_finsh" label="会员消费总额-已完成-微信" sortable>
            <template slot-scope="{ row }">
              ¥ {{ row.totalConsumption_finsh.toLocaleString() }}
            </template>
          </el-table-column>

          <el-table-column prop="totalConsumption_finsh_banl" label="会员消费总额-已完成-余额" sortable>
            <template slot-scope="{ row }">
              ¥ {{ row.totalConsumption_finsh_banl.toLocaleString() }}
            </template>
          </el-table-column>

          <el-table-column prop="totalConsumptionAll" label="会员消费总订单总额-微信" sortable>
            <template slot-scope="{ row }">
              ¥ {{ row.totalConsumptionAll.toLocaleString() }}
            </template>
          </el-table-column>

          <el-table-column prop="totalConsumptionAll_banl" label="会员消费总订单总额-余额" sortable>
            <template slot-scope="{ row }">
              ¥ {{ row.totalConsumptionAll_banl.toLocaleString() }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import StatisticsApi from '@/api/statistics.js';
import qs from 'qs';

export default {
  data() {
    return {
      dateRange: [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()],
      loading: false,
      tableData: [],
      multipleSelection: []
    };
  },
  
  mounted() {
    this.loadData();
  },
  
  methods: {
    // selectable(row, index) {
    //   // 只有非表头行（商品行）可以选择
    //   return !row.is_top_row;
    // },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    exportData: function() {
      let baseUrl = window.location.protocol + '//' + window.location.host;
      
      // 创建导出参数对象
      let params = {
        startDate: this.formatDate(this.dateRange[0]),
        endDate: this.formatDate(this.dateRange[1])
      };
      
      // 如果有选中的业务员，则导出选中的数据
      // if (!this.multipleSelection) {
      //   let ids = [];
      //   this.multipleSelection.map((item)=>{
      //     // 确保只导出有效的业务员ID
      //     if (item.id && !item.is_top_row) {
      //       ids.push(item.id);
      //     }
      //   });
        
      //   if (!ids) {
      //     params.ids = ids.join(",");
      //     console.log('导出选中的业务员IDs:', ids);
      //   }
      // }
      
      // 构建导出URL
      const exportUrl = baseUrl + '/index.php/shop/statistics.ywy/export1?' + qs.stringify(params);
      console.log('导出URL:', exportUrl);
      
      // 使用window.open或location.href导出
      window.location.href = exportUrl;
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    
    loadData() {
      this.loading = true;
      const params = {
        startDate: this.formatDate(this.dateRange[0]),
        endDate: this.formatDate(this.dateRange[1]),
        timeUnit: 'month'
      };

      StatisticsApi.ywy_index1(params)
        .then(res => {
          const data = res.data;
          // 只保留业务员列表数据
          this.tableData = data.salesman || [];
          this.loading = false;
        })
        .catch(error => {
          console.error('加载数据失败:', error);
          this.loading = false;
        });
    },
    
    querys() {
      this.loadData();
    }
  }
};
</script>

<style scoped>
.el-date-picker {
  --el-date-editor-width: 320px;
}

:deep(.el-range-editor.el-input__wrapper) {
  border-radius: 6px;
}

:deep(.el-select .el-input__wrapper) {
  border-radius: 6px;
}

:deep(.el-button) {
  border-radius: 6px;
}
</style>


// WEBPACK FOOTER //
// src/views/statistics/ywy/index1.vue